import {Fragment, h} from "preact";
import s from "./input.module.css";
import {useAppContext} from "../../contexts";

/**
 * A simple input component that can be used globally in the application.
 * Provides error messages support through the `error` property.
 * */
const Input = props => {
    // Destructured component props
    const {
        type,
        label,
        name,
        handleChange,
        placeholder,
        value,
        error = undefined,
        isRequired = false,
        className = undefined,
        dataTestId = null,
        subLabel = undefined,
        ...rest
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <fieldset className={"w-full flex flex-col justify-start gap-y-1"}>
                <label
                    htmlFor={`${name}-input`}
                    className={`${s.label} ${highContrast ? "highLabelFourth" : ""}`}
                    data-testid="generic-input-label"
                >
                    {label}&nbsp;
                    <span
                        className={`${!isRequired ? "hidden" : ""} ${highContrast ? "highLabelSecond" : "text-sabin-red-default"}`}
                        data-testid="generic-input-required-label"
                    >
                        *
                    </span>
                    <span
                        className={`${!subLabel ? "hidden" : ""} ${highContrast ? "highLabelSecond" : ""}`}
                        data-testid="generic-input-required-label"
                    >
                        &nbsp;&nbsp;{subLabel}
                    </span>
                </label>
                <div className={"relative w-full"}>
                    <input
                        type={type}
                        className={`
                            ${s.input} 
                            ${error
                            ? ` ${highContrast ? "highIsInvalid" : s.isInvalid}` 
                                : (!error && value) ? ` ${highContrast ? "highIsValid" : s.isValid}` : ""
                            } 
                            ${`${highContrast ? "highLabelThird" : ""}`}
                            ${className}`
                        }
                        placeholder={placeholder}
                        id={`${name}-input`}
                        name={name}
                        onInput={handleChange}
                        value={value}
                        {...rest}
                        data-testid={dataTestId || 'generic-input'}
                    />
                </div>
                {!!error && (
                    <p className={`${s.errorMessage} ${highContrast ? "highTitleThird" : "text-sabin-red-default"}`}>
                        {error}
                    </p>
                )}
            </fieldset>
        </Fragment>
    )
}

export default Input;
